module.exports = __webpack_public_path__ + "media/icons/business-checklist-gray-e5e1f3a9.png";